<script>
import Carregando from '~componentes/Carregando.vue';
import centralMensagensServico from '../servico';
import sessaoAvisos from '../sessao-avisos';
import sessaoDesktop from '../sessao-desktop';
import desktopEmbed from '~js/desktop-embed';

export default {
  components: {
    Carregando
  },
  data() {
    return {
      carregando: true,
      erro: '',
      avisos: false,
      tentando: false,
    }
  },
  mounted() {
    this.iniciarSessao();
  },
  watch: {
    '$route.query.token'(novo, antigo) {
      if (!novo || novo === antigo) return;
      clearInterval(this._novaSessao);
      this.erro = '';
      this.carregando = true;
      this.iniciarSessao();
    },
  },
  beforeDestroy() {
    clearInterval(this._novaSessao);
  },
  methods: {
    iniciarSessao() {
      const token = this.$route.query.token;

      if (!token) {
        this.carregando = false;
        this.erro = 'Não foi possível abrir a Central de Mensagens. Acesse novamente pelo sistema.';
        return;
      }

      const avisos = this.$route.query.tela === 'avisos';
      this.avisos = avisos;

      if (!avisos)
        this.$storage.limpar();

      return centralMensagensServico
        .iniciarSessao(token)
        .then(dados => {
          if (avisos) {
            sessaoAvisos.token = dados.token;
            this.$router.replace({ name: 'central-mensagens.avisos' });
            return;
          }

          this.$storage.usuario(dados.usuario);
          this.$storage.token(dados.token);

          const p = dados.parametros || {};
          const query = {};

          sessaoDesktop.modulosAbrir = Array.isArray(p.modulosAbrir) ? p.modulosAbrir.map(m => +m) : null;

          if (p.modulo > 0) query.modulo = '' + p.modulo;
          if (p.idProjeto > 0) query.projeto = '' + p.idProjeto;
          if (p.numero > 0) query.numero = '' + p.numero;
          if (p.situacao) query.situacao = p.situacao;

          const conversa = this.$route.query.tela === 'conversa' && p.modulo > 0 && p.numero > 0;
          this.$router.replace({ name: conversa ? 'central-mensagens.conversa' : 'central-mensagens', query });
        })
        .catch(() => {
          this.carregando = false;
          if (!avisos) {
            this.erro = 'Sessão expirada ou inválida. Feche esta janela e abra novamente pelo sistema.';
            return;
          }
          this.erro = 'Não foi possível conectar aos avisos agora.';
          this.pedirNovaSessao();
          clearInterval(this._novaSessao);
          this._novaSessao = setInterval(() => this.pedirNovaSessao(), 65000);
        });
    },
    pedirNovaSessao() {
      this.tentando = true;
      setTimeout(() => { this.tentando = false; }, 4000);
      if (!desktopEmbed.enviar({ acao: 'sessaoExpirada' }))
        window.location.reload();
    },
  }
}
</script>

<template>
  <div style="padding: 20px">
    <carregando v-if="carregando"></carregando>

    <div v-if="erro && avisos" class="ses-avisos">
      <div class="ses-avisos-ic"><i class="fa fa-plug"></i></div>
      <b>Avisos indisponíveis</b>
      <p>{{ erro }} A conexão é refeita sozinha em instantes.</p>
      <button type="button" class="ses-btn" :disabled="tentando" @click="pedirNovaSessao">
        <i class="fa" :class="tentando ? 'fa-spinner fa-pulse' : 'fa-refresh'"></i> {{ tentando ? 'Reconectando…' : 'Tentar novamente' }}
      </button>
    </div>

    <div v-else-if="erro" class="ibox float-e-margins">
      <div class="ibox-content text-center">
        <h2>Central de Mensagens</h2>
        <div class="alert alert-warning no-margin-bottom">
          {{ erro }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .ses-avisos { display: flex; flex-direction: column; align-items: center; gap: 8px; margin-top: 40px; padding: 28px 20px; text-align: center; background: #fff; border: 1px solid #e1e5ea; border-radius: 8px; color: #5b6570; font-size: 13px; }
  .ses-avisos-ic { width: 48px; height: 48px; border-radius: 50%; background: #fff6e5; color: #9a5b00; display: flex; align-items: center; justify-content: center; font-size: 20px; }
  .ses-avisos b { font-size: 14px; color: #1c2024; }
  .ses-avisos p { margin: 0; max-width: 300px; line-height: 1.45; }
  .ses-btn { margin-top: 6px; display: inline-flex; align-items: center; gap: 7px; background: #e3f4ee; border: 1px solid #c3e6d8; border-radius: 5px; padding: 8px 18px; font-size: 12.5px; font-weight: 600; color: #0a6d4d; }
  .ses-btn:hover { background: #d4ede3; }
  .ses-btn:disabled { opacity: .7; cursor: default; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/central-mensagens/componentes/Sessao.vue